import { filterMenuItemsByRole } from "@utils/index";

// Base menu items - will be filtered based on user role
export const baseMenuItems = [
  {
    id: "home",
    label: "Home",
    path: "/dashboard",
    icon: "home",
  },
  {
    id: "bookings",
    label: "Policies",
    path: "/bookings",
    icon: "booking",
  },
  {
    id: "claims",
    label: "Claims",
    path: "/claims",
    icon: "claims",
  },
  {
    id: "vouchers",
    label: "Vouchers",
    path: "/vouchers",
    icon: "voucher",
  },
  {
    id: "client-management",
    label: "Client Management",
    path: "/client-management",
    icon: "userManagement",
  },
  {
    id: "cdBalance-claims",
    label: "C/D Balance Claims",
    path: "/cd-balance-claims",
    icon: "totalAmountIcon",
  },
  {
    id: "cdBalance-premium",
    label: "C/D Balance Premium",
    path: "/cd-balance-premium",
    icon: "totalAmountIcon",
  },
];

// Legacy export for backward compatibility
export const menuItems = baseMenuItems;

export const sidebarConfig = {
  logo: "Alternate Travel Plan",
  abbreviation: "ATP",
  mobileBreakpoint: 960,
  logoutIcon: "logout",
  logoutLabel: "Logout",
};

export const logoutModalConfig = {
  title: "Confirm Logout",
  message: "Are you sure you want to logout?",
  confirmText: "Logout",
  cancelText: "Cancel",
};

export const handleNavigationLogic = (
  path,
  navigate,
  setActivePath,
  onClose,
) => {
  navigate(path);
  setActivePath(path);
  // Close sidebar on mobile after navigation
  if (window.innerWidth <= sidebarConfig.mobileBreakpoint) {
    onClose();
  }
};

export const getMenuItemClassName = (activePath, itemPath) => {
  return `sidebar__menu-link ${
    activePath === itemPath ? "sidebar__menu-link--active" : ""
  }`;
};

export const getSidebarClassName = (isOpen, isCollapsed, isMobile) => {
  if (isMobile) {
    return `sidebar ${isOpen ? "sidebar--open" : "sidebar--closed"}`;
  }
  return `sidebar sidebar--desktop ${
    isCollapsed ? "sidebar--collapsed" : "sidebar--expanded"
  }`;
};

/**
 * Get filtered menu items based on user role
 * @param {Object} user - User object with role property
 * @returns {Array} - Filtered menu items
 */
export const getFilteredMenuItems = (user) => {
  if (!user || !user.role) return [];

  return filterMenuItemsByRole(baseMenuItems, user);
};

export const handleLogout = (navigate, toastService) => {
  try {
    // Clear any stored auth data
    localStorage.clear();
    sessionStorage.clear();

    // Show success toast
    toastService.success("Log out successfully!");

    // Redirect to login page
    setTimeout(() => {
      navigate("/");
    }, 500);
  } catch (error) {
    toastService.error("Logout failed. Please try again.");
  }
};
